import { render, staticRenderFns } from "./attachAFile.vue?vue&type=template&id=3161e764&"
import script from "./attachAFile.vue?vue&type=script&lang=js&"
export * from "./attachAFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports